import Icon from "../assets/icons";
import { Outlet, useLocation } from "react-router-dom";

const GuestLayout = () => {
  const location = useLocation();
  const isSignup = location.pathname === '/signup';
  // const backgroundImage = "/img/background.png";
  const backgroundImage = isSignup
    ? "/img/SignUp2.png" 
    : "/img/background.png";
  return (
    <div className="bg-white mt-16 rounded-t-2xl h-screen grid grid-cols-2">
      <div className="bg-[#F1F3FF] mobile:col-span-2 rounded-t-2xl ">
        {/* <div className="mt-6 ml-10">
          <img width={130} src={Icon.secondLogo} alt="Icon Image" />
        </div> */}
        <div >
          <Outlet></Outlet>
        </div>
        <div className="absolute bottom-16 left-7 font-semibold">
          &copy; VTT Technologies 2025
        </div>
      </div>
      <div
        className="bg-cover sepia bg-center bg-no-repeat p-10 mobile:hidden"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      ></div>
    </div>
  );
};

export default GuestLayout;
